import { render, staticRenderFns } from "./CustomToast.vue?vue&type=template&id=5af6c4f4&scoped=true&"
import script from "./CustomToast.vue?vue&type=script&lang=js&"
export * from "./CustomToast.vue?vue&type=script&lang=js&"
import style0 from "./CustomToast.vue?vue&type=style&index=0&id=5af6c4f4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5af6c4f4",
  null
  
)

export default component.exports